<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1">Cấu hình lớp</v-tab>
      <v-tab v-if="event.isPublished" class="tab-default" :key="2">Báo cáo</v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <EventTabConfig />
        </v-tab-item>
        <v-tab-item :key="2">
          <EventTabReport />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EventTabConfig from './EventTabConfig.vue'
import EventTabReport from './EventTabReport.vue'
export default {
  components: { EventTabConfig, EventTabReport },
  data: () => ({ tab: null }),
  computed: {
    ...mapGetters({ event: 'events/getItem' })
  }
}
</script>
